<template>
	<div class="db-companies-search flex-1">
		<el-input v-model="filter.search" @input="onChange" clearable placeholder="Search company" :prefix-icon="SearchIcon" size="large"> </el-input>
	</div>
</template>

<script lang="js" setup>
import SearchIcon from "@/components/Svg/SearchIcon.vue";
import filter from "@/pages/Company/filter";
import { ref } from "vue";

const search = ref("");
const select = ref(1);

const onChange = () => {
	filter.value.reload++;
};
</script>
